import React, { useState } from "react";

const AccordionContainer = (props) => {
  const [displayAccordion, setDisplayAccordion] = useState(false);
  const { icon, title, children } = props;

  const handleAccordion = () => {
    setDisplayAccordion(!displayAccordion);
  };

  return (
    <div className="f-col-s12 padless m-bottom-2 element-accordion refreshed-accordion">
      <button
        type="button"
        className={`refreshed-accordion-toggle${displayAccordion ? " is-open" : ""}`}
        onClick={handleAccordion}
        aria-expanded={displayAccordion}
      >
        <span className="refreshed-accordion-icon" aria-hidden="true">
          <i className={displayAccordion ? "bx bx-minus" : "bx bx-plus"} />
        </span>
        {icon ? <span className="refreshed-accordion-leading-icon">{icon}</span> : null}
        <span className="refreshed-accordion-title">{title}</span>
        <span className="refreshed-accordion-chevron" aria-hidden="true">
          <i className="bx bx-chevron-down" />
        </span>
      </button>

      {displayAccordion ? (
        <div className="refreshed-accordion-content">{children}</div>
      ) : null}

      <div className="clearfix" />
    </div>
  );
};

export default AccordionContainer;
